module.exports = __webpack_public_path__ + "static/wakeups-30546dceac4ce44294e759c133937dcd.png";